import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function FadeUp({ children, delay = 0, className = "", y = 48, immediate = false }) {
  const motionProps = immediate
    ? { animate: { opacity: 1, y: 0 } }
    : { whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" } };
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      {...motionProps}
      transition={{ duration: 1.1, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskLine({ children, delay = 0, className = "", innerClassName = "", immediate = false }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const show = immediate || inView;
  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className={`block will-change-transform ${innerClassName}`}
        initial={{ y: "115%" }}
        animate={show ? { y: "0%" } : { y: "115%" }}
        transition={{ duration: 1.3, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <FadeUp y={20} className={`flex items-center gap-4 ${className}`}>
      <span className="h-px w-10 bg-current opacity-40" aria-hidden />
      <span className="text-[11px] font-semibold uppercase tracking-[0.32em] opacity-70">{children}</span>
    </FadeUp>
  );
}
